import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReasonCodeInitialState, ReasonCodeLoad } from './reason-code.actions';
import { ReasonCodeService } from './reason-code.service';
import { catchError, map } from 'rxjs/operators';
import { Error, CustomHttpErrorResponse } from '../../../../common/constants/error';
import { NotificationService } from '../../../../common';
import { FilterPopupChipsModel } from '../models/filter-popup-chips.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ReasonCodeStateModel {
  reasonCodes: FilterPopupChipsModel[];
  loaded: boolean;
}

const initialState: ReasonCodeStateModel = {
  reasonCodes: null,
  loaded: false,
};

@State<ReasonCodeStateModel>({
  name: 'reasonCodes',
  defaults: initialState,
})
@Injectable()
export class ReasonCodeState {
  constructor(private reasonCodeService: ReasonCodeService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: ReasonCodeStateModel): ReasonCodeStateModel {
    return state;
  }

  @Selector()
  static getReasonCode(state: ReasonCodeStateModel): FilterPopupChipsModel[] {
    return state.reasonCodes;
  }

  @Selector()
  static getLoaded(state: ReasonCodeStateModel): boolean {
    return state.loaded;
  }

  @Action(ReasonCodeLoad)
  getReasonCode(ctx: StateContext<ReasonCodeStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.reasonCodeService.getReasonCode().pipe(
      map((reasonCodes: FilterPopupChipsModel[]) => {
        ctx.patchState({ reasonCodes, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ReasonCodeInitialState)
  setInitialState(ctx: StateContext<ReasonCodeInitialState>): void {
    ctx.setState(initialState);
  }
}
